module.exports = "<router-outlet></router-outlet>\n<app-loader></app-loader>"